module.exports = __webpack_public_path__ + "img/github.07883e93.svg";